import api from '../api';

const handleResponse = async (promise) => {
    try {
        const response = await promise;
        return { data: response.data, error: null, code: null, status: response.status };
    } catch (error) {
        const message = error.response?.data?.error || error.response?.data?.message || error.message;
        return { data: null, error: message, code: error.response?.data?.code || null, status: error.response?.status || null };
    }
};

// Orchestrated start: the backend runs prepare -> load -> wait-loaded -> play
// -> wait-playing and answers 202 immediately; progress arrives over sockets.
export const startMovie = (movieId, orderId) =>
    handleResponse(api.post(`/movies/${movieId}/order/${orderId}/start`));

export const playMovie = (movieId, orderId) =>
    handleResponse(api.post(`/movies/${movieId}/order/${orderId}/play`));

export const pauseMovie = (movieId, orderId) =>
    handleResponse(api.post(`/movies/${movieId}/order/${orderId}/pause`));

export const ejectMovie = (movieId, orderId, { force = false } = {}) =>
    handleResponse(api.post(`/movies/${movieId}/order/${orderId}/eject${force ? '?force=true' : ''}`));

export const goToTimecode = (movieId, orderId, timecode) =>
    handleResponse(api.post(`/movies/${movieId}/order/${orderId}/go-to-timecode`, { timecode }));

export const getPlayStatus = (movieId, orderId) =>
    handleResponse(api.get(`/movies/${movieId}/order/${orderId}/play-status`));

export const getPlayingMovie = () =>
    handleResponse(api.get('/orders/get-playing-movie'));
